module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_vm._t("tr-th"), _vm._v(" "), _vm._t("tr-td")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351c231e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Table/TableCell.vue
// module id = 1329
// module chunks = 0